<div class="row p-2 no-gutters">

  <!--Header-->
  <div class="col-4">
    <img class="img-fluid invoice-logo" src="assets/images/logo/nissan-next-logo-black.png" alt="logo" />
  </div>
  <div class="col-4 text-center pt-1 font16-700">
    <span class="border border-solid disabled-span"
      [ngClass]="{'PAID':'text-success border-success', 'VOIDED':'text-danger border-danger'}[invoice.invoiceStatus]">
      &nbsp;{{invoice.invoiceStatus}}&nbsp;</span><br>
    <div *ngIf="(invoice.invoiceStatus == 'OPEN' || invoice.invoiceStatus == 'OVERDUE') && invoice.paymentStatus" class="font13-400-maroon italic mt-1">
      &#60;&#60; Payment {{invoice.paymentStatus | customText}} &#62;&#62;
    </div>
  </div>
  <div class="col-4 text-right font13-400">
    <div>Invoice Date: {{invoice.invoiceDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}</div>
    <div>Invoice #: {{invoice.invoiceNumber}}</div>
    <div *ngIf="invoice.poNumber">PO #: {{invoice.poNumber}}</div>
    <div>Due Date: {{invoice.invoiceSummary.dueDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}</div>
    <div class="font14-700">{{invoice.invoiceSummary.total | number : '1.2-2'}} {{invoice.invoiceSummary.currency}}
    </div>
  </div>
  <!--Customer detail-->
  <div class="col-12">
    <div class="row no-gutters">
      <div class="col-lg-5 col-md-5 col-sm-4 col-5 mt-4 pl-1 py-2 p-md-2 bg-light">
        <div class="font13-600">Customer Information</div>
        <div class="font13-400">{{invoice.customerInfo.accountInfo.name}}</div>
        <div *ngIf="invoice.customerInfo.accountInfo.address" class="font13-400">
          <span
            *ngIf="invoice.customerInfo.accountInfo.address.street">{{invoice.customerInfo.accountInfo.address.street}},&nbsp;</span><br>
          <span
            *ngIf="invoice.customerInfo.accountInfo.address.city">{{invoice.customerInfo.accountInfo.address.city}},&nbsp;</span>
          <span
            *ngIf="invoice.customerInfo.accountInfo.address.state">{{invoice.customerInfo.accountInfo.address.state}},&nbsp;</span><br>
          <span
            *ngIf="invoice.customerInfo.accountInfo.address.country">{{invoice.customerInfo.accountInfo.address.country}},&nbsp;</span>
          <span
            *ngIf="invoice.customerInfo.accountInfo.address.zipCode">{{invoice.customerInfo.accountInfo.address.zipCode}}</span>
        </div>
      </div>
      <div class="col-lg-5 col-md-4 col-sm-4 col-5 mt-4 py-2 p-md-2 bg-light">
        <div class="font13-600">Billing Address</div>
        <div class="font13-400">{{invoice.customerInfo.billingInfo.name}}</div>
        <div *ngIf="invoice.customerInfo.billingInfo.address" class="font13-400">
          <span
            *ngIf="invoice.customerInfo.billingInfo.address.street">{{invoice.customerInfo.billingInfo.address.street}},&nbsp;</span><br>
          <span
            *ngIf="invoice.customerInfo.billingInfo.address.city">{{invoice.customerInfo.billingInfo.address.city}},&nbsp;</span>
          <span
            *ngIf="invoice.customerInfo.billingInfo.address.state">{{invoice.customerInfo.billingInfo.address.state}},&nbsp;</span><br>
          <span
            *ngIf="invoice.customerInfo.billingInfo.address.country">{{invoice.customerInfo.billingInfo.address.country}},&nbsp;</span>
          <span
            *ngIf="invoice.customerInfo.billingInfo.address.zipCode">{{invoice.customerInfo.billingInfo.address.zipCode}}</span>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-4 col-2 mt-4 py-2 pr-1 p-md-2 bg-light text-right">
        <div class="font13-600">Account Number</div>
        <div class="font13-400">{{invoice.accountNumber}}</div>
      </div>
    </div>
  </div>
  <!--Summary Table-->

  <div class="col-md-6 col-12 table-responsive no-gutter mt-4 pr-md-3">
    <table class="table table-borderless">
      <thead class="font13-600 thead-light">
        <tr>
          <th scope="col" colspan="2">Product Details</th>
        </tr>
      </thead>
      <tbody class="font13-400">
        <tr>
          <td width="50%" class="paddingx-2">Products:</td>
          <td class="text-right paddingx-2" width="50%">
            <div *ngFor="let packageDetail of invoice.invoiceSummary.items">
              <span>{{packageDetail.name}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="paddingx-2">Billing Period:</td>
          <td class="text-right paddingx-2">
            {{invoice.invoiceSummary.billingPeriod.startDate |
              date: utilService.countryData.dateFormat : utilService.countryData.timezone}}-{{invoice.invoiceSummary.billingPeriod.endDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}
          </td>
        </tr>
        <tr>
          <td class="paddingx-2">Payment Term:</td>
          <td class="text-right paddingx-2">NET {{invoice.invoiceSummary.paymentTerm}}</td>
        </tr>
        <tr>
          <td class="paddingx-2">Due Date:</td>
          <td class="text-right paddingx-2">{{invoice.invoiceSummary.dueDate | date: utilService.countryData.dateFormat : utilService.countryData.timezone}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-md-6 col-12 table-responsive no-gutter mt-4 pl-md-3">
    <table class="table table-borderless">
      <thead class="font13-600 thead-light">
        <tr>
          <th scope="col" colspan="2">Bill Summary</th>
        </tr>
      </thead>
      <tbody class="font13-400">
        <tr>
          <td class="paddingx-2">Charges:</td>
          <td class="text-right paddingx-2">{{invoice.invoiceSummary.subTotal | number : '1.2-2'}}</td>
        </tr>
        <tr>
          <td class="paddingx-2">Discount:</td>
          <td class="text-right paddingx-2">{{invoice.invoiceSummary.discounts | number : '1.2-2'}}</td>
        </tr>
        <tr>
          <td class="paddingx-2">Credits:</td>
          <td class="text-right paddingx-2">{{invoice.invoiceSummary.credits | number : '1.2-2'}}</td>
        </tr>
        <tr>
          <td class="paddingx-2">Tax:</td>
          <td class="text-right paddingx-2">
            <div *ngIf="invoice.invoiceSummary.taxes == 0; else second">NA</div>
            <ng-template #second>{{invoice.invoiceSummary.taxes | number : '1.2-2'}}</ng-template>
          </td>
        </tr>
        <tr class="font14-700">
          <td class="paddingx-2">Total:</td>
          <td class="text-right paddingx-2">{{invoice.invoiceSummary.total | number : '1.2-2'}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!--Service Package wise breakup-->
  <ng-container *ngFor="let packageDetail of invoice.invoiceBreakdown">
    <div class="col-12 table-responsive no-gutter mt-4">
      <table class="table table-borderless">
        <thead class="font13-600">
          <tr>
            <th *ngIf="isLicenseOrFlatOrPrepaid(packageDetail.ratePlanType) else showPackageNameAndAppliedAs" scope="col" class="p-2 bg-light" colspan="9">&nbsp;</th>
            <ng-template #showPackageNameAndAppliedAs>
              <th scope="col" class="p-2 bg-light" colspan="9">{{packageDetail.name}}
                <span
                  *ngIf="packageDetail.appliedAs && packageDetail.appliedAs != 'PREMIUM'">({{packageDetail.appliedAs}})</span>
              </th>
            </ng-template>
          </tr>          
          <tr>
            <th *ngIf="isLicenseOrFlatOrPrepaid(packageDetail.ratePlanType) else noPackage" scope="col" width="20%">Package</th>
            <ng-template #noPackage>
              <th scope="col" width="20%">Package Services</th>
            </ng-template>
            <th class="text-right" scope="col" width="10%"><span *ngIf="isLicenseOrFlatOrPrepaid(packageDetail.ratePlanType)">Vehicles</span></th>
            <th class="text-right" scope="col" width="10%">Units</th>
            <th class="text-right" scope="col" width="10%">Rate</th>
            <th class="text-right" scope="col" width="10%">Sub-Total</th>
            <th class="text-right" scope="col" width="10%">
              <span *ngIf="packageDetail.revenueShare && packageDetail.revenueShare.value else noRevenueShare">
                Revenue Share
              </span>
              <ng-template #noRevenueShare>
                Discounts
              </ng-template>
            </th>
            <!-- <th class="text-right" scope="col" width="10%">Discounts</th> -->
            <th class="text-right" scope="col" width="10%">Tax Rates</th>
            <th class="text-right" scope="col" width="10%">Taxes</th>
            <th class="text-right" scope="col" width="10%">Total</th>
          </tr>
        </thead>
        <tbody class="font13-400">
          <ng-container *ngIf="isLicenseOrFlatOrPrepaid(packageDetail.ratePlanType)">
            <tr>
              <!-- <td>
                <ol class="font12-400">
                  <li *ngFor="let service of packageDetail.serviceLineItems">{{service.name}}</li>
                </ol>
                >!-- <div class="font12-400" *ngFor="let service of packageDetail.serviceLineItems; let i=index;">{{i+1}}. {{service.name}}</div> --<
              </td> -->
              <td class="font13-600">{{packageDetail.name}}</td>
              <td class="text-right" *ngIf="packageDetail.vehicleCount">{{packageDetail.vehicleCount | number:'1.0-0': LOCALE}}</td>
              <td class="text-right" *ngIf="!packageDetail.vehicleCount">-</td>
              <td class="text-right" rowspan="packageDetail.services.length">{{packageDetail.units | number:'1.2-2': LOCALE}}</td>
              <td class="text-right" rowspan="packageDetail.services.length">
                <span
                  *ngIf="packageDetail.ratePlanType !='PREPAID' && 
                ((packageDetail.appliedAs && packageDetail.appliedAs == 'PREMIUM') || !packageDetail.appliedAs)">{{packageDetail.rate
                  | number : '1.2-2'}}</span>
                <span *ngIf="packageDetail.ratePlanType=='PREPAID' || packageDetail.appliedAs == 'TRIAL'">NA</span>
              </td>
              <td class="text-right" rowspan="packageDetail.services.length">
                {{packageDetail.subTotal | number : '1.2-2'}}</td>
              <td class="text-right" rowspan="packageDetail.services.length">
                <span *ngIf="packageDetail.revenueShare && packageDetail.revenueShare.value else noRevenueShare">
                  <span *ngIf="packageDetail.revenueShare.revenueShareType == 'PERCENTAGE' else absoluteRevenue">
                    {{packageDetail.revenueShare.value}}%
                  </span>
                  <ng-template #absoluteRevenue>
                    {{packageDetail.revenueShare.value | number : '1.2-2'}}
                  </ng-template>
                </span>
                <ng-template #noRevenueShare>
                  <span
                    *ngIf="packageDetail.ratePlanType !='PREPAID' &&
                  ((packageDetail.appliedAs && packageDetail.appliedAs == 'PREMIUM') || !packageDetail.appliedAs)">{{packageDetail.discounts
                    | number : '1.2-2'}}</span>
                  <span *ngIf="packageDetail.ratePlanType=='PREPAID' || packageDetail.appliedAs == 'TRIAL'">NA</span>

                </ng-template>
              </td>
              <td class="text-right" rowspan="packageDetail.services.length">
                <span *ngIf="packageDetail.taxRates == 0">NA</span>
                <span *ngIf="packageDetail.taxRates > 0">{{packageDetail.taxRates * 100 | number : '1.0-1'}}%</span>
              </td>
              <td class="text-right" rowspan="packageDetail.services.length">
                <ng-container *ngIf="packageDetail.taxRates == 0 && packageDetail.taxes == 0; else second">NA</ng-container>
                <ng-template #second>
                  <ng-container *ngIf="packageDetail.taxRates > 0 && packageDetail.taxes == 0; else third">-</ng-container>
                </ng-template>
                <ng-template #third>{{packageDetail.taxes | number : '1.2-2'}}</ng-template>
              </td>
              <td class="text-right" rowspan="packageDetail.services.length">{{packageDetail.total | number : '1.2-2'}}
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="packageDetail.ratePlanType=='DEFAULT_SERVICE_RATES' || packageDetail.ratePlanType == 'DEFAULT_SERVICE_RATES_OVERAGE_PRICING'">
            <tr *ngFor="let service of packageDetail.serviceLineItems; let i=index">
              <td class="py-0 font12-400">{{i+1}}. {{service.name}}</td>
              <td class="py-0 text-right"></td>
              <td class="py-0 text-right">{{service.units | number:'1.2-2': LOCALE}}</td>
              <td class="py-0 text-right">{{service.rate | number : '1.2-2'}}</td>
              <td class="py-0 text-right">{{service.subTotal | number : '1.2-2'}}</td>
              <td class="py-0 text-right"> - </td>
              <td class="py-0 text-right"> - </td>
              <td class="py-0 text-right"> - </td>
              <td class="py-0 text-right">{{service.subTotal | number : '1.2-2'}}</td>
            </tr>
          </ng-container>
          <tr class="font14-700"
            *ngIf="packageDetail.ratePlanType =='DEFAULT_SERVICE_RATES' || packageDetail.ratePlanType == 'DEFAULT_SERVICE_RATES_OVERAGE_PRICING'">
            <td colspan="4">Sub-Total:</td>
            <td class="text-right"> {{packageDetail.subTotal | number : '1.2-2'}} </td>
            <td class="text-right">
              <span *ngIf="packageDetail.revenueShare && packageDetail.revenueShare.value else noRevenueShare">
                <span *ngIf="packageDetail.revenueShare.revenueShareType == 'PERCENTAGE' else absoluteRevenue">
                  {{packageDetail.revenueShare.value}}%
                </span>
                <ng-template #absoluteRevenue>
                  {{packageDetail.revenueShare.value | number : '1.2-2'}}
                </ng-template>
              </span>
              <ng-template #noRevenueShare>
                {{packageDetail.discounts | number : '1.2-2'}}
              </ng-template>
            </td>
            <td class="text-right">
              <span *ngIf="packageDetail.taxRates == 0">NA</span>
              <span *ngIf="packageDetail.taxRates > 0">{{packageDetail.taxRates * 100 | number : '1.0-1'}}%</span>
            </td>
            <td class="text-right">
              <ng-container *ngIf="packageDetail.taxRates == 0 && packageDetail.taxes == 0; else second">NA</ng-container>
              <ng-template #second>
                <ng-container *ngIf="packageDetail.taxRates > 0 && packageDetail.taxes == 0; else third">-</ng-container>
              </ng-template>
              <ng-template #third>{{packageDetail.taxes | number : '1.2-2'}}</ng-template>
            </td>
            <td class="text-right">{{packageDetail.total | number : '1.2-2'}}</td>
          </tr>

          <tr class="font14-700"
            *ngIf="packageDetail.ratePlanType !='DEFAULT_SERVICE_RATES' && packageDetail.ratePlanType != 'DEFAULT_SERVICE_RATES_OVERAGE_PRICING'">
            <td colspan="7">Sub-Total:</td>
            <td class="text-right">
              <ng-container *ngIf="packageDetail.taxRates == 0 && packageDetail.taxes == 0; else second">NA</ng-container>
              <ng-template #second>
                <ng-container *ngIf="packageDetail.taxRates > 0 && packageDetail.taxes == 0; else third">-</ng-container>
              </ng-template>
              <ng-template #third>{{packageDetail.taxes | number : '1.2-2'}}</ng-template>
            </td>
            <td class="text-right">{{packageDetail.total | number : '1.2-2'}}</td>
          </tr>

        </tbody>
      </table>
    </div>
  </ng-container>


  <!-- End Customers-->
  <!-- <div *ngIf="invoice.customTexts && invoice.customTexts.length > 0" class="col-12 mt-2">
    <div class="row no-gutters" *ngFor="let customer of invoice.customTexts; let i = index">
      <div class="col-lg-3 col-md-4 col-4 pl-1 font13-400" *ngFor="let item of customer.rowFields">
        {{item.key}}: {{item.value}}
      </div>
    </div>
  </div> -->

  <div *ngIf="invoice.customTexts && invoice.customTexts.length > 0" class="col-12 mt-4">
    <div class="row no-gutters" *ngFor="let customer of invoice.customTexts">
      <div class="col-12 p-1 font13-400">
        <span *ngFor="let item of customer.rowFields; let i = index">
          <span *ngIf="i==0"><span class="font13-600">{{item.key}}:</span>&nbsp;{{item.value}}</span>
          <span *ngIf="i!=0">;&nbsp;&nbsp;&nbsp;<span class="font13-600">{{item.key}}:</span>&nbsp;{{item.value}}</span>
        </span>
      </div>
    </div>
  </div>


  <!-- <div *ngIf="invoice.customRows && invoice.customRows.length > 0" class="col-12 mt-2">
    <div class="row font13-400 mt-2" *ngFor="let customer of invoice.customTexts; let i = index">
      <div class="col-lg-3 col-md-4 col-4" *ngFor="let item of customer.rowFields">{{item.key}}: {{item.value}}</div>
    </div>
  </div> -->

</div>

<div class="row justify-content-center no-gutter mt-4 mb-2">
  <div class="col-auto">
    <table class="table table-borderless table-responsive">
      <thead>
        <th colspan="2" class="text-center padding3">{{billingService.wireTransferStatement}}<br /><br /></th>
      </thead>
      <tbody class="font13-400 mt-2">
        <tr *ngFor="let line of wireTransferAddress">
          <td class="text-right padding3">{{line[0]}}</td>
          <td class="text-left padding3 padding-left">{{line[1]}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>